import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
} from 'shards-react';

import { FiAlertCircle, FiArrowLeft, FiZoomIn } from 'react-icons/fi';

import PageTitle from '../../components/common/PageTitle';

import { getAllInstitutionsRequest } from '../../store/modules/institution/actions';
import {
  documentRepairTypes,
  documentFixGroups,
  repairResultStatus,
} from '../../config/Constants';

import { dateAndSeconds } from '../../utils/dateFormatter';
import { showErrorLogModal } from '../../utils/errorLogModal';

const documentTypeLabelByValue = Object.fromEntries(
  documentRepairTypes.map((t) => [t.value, t.label])
);

const documentFixGroupLabelByValue = Object.fromEntries(
  documentFixGroups.map((g) => [g.value, g.label])
);

export default function DocumentRepairLogDetails() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const doc = location.state?.doc;

  const institutions = useSelector((state) => state.institution.institutions);

  const institutionByClientId = institutions
    ? Object.fromEntries(institutions.map((i) => [i.client_id, i]))
    : {};

  const institution = doc ? institutionByClientId[doc.client_id] : null;
  const institutionLabel = institution
    ? `${institution.name} - ${institution.initials}`
    : doc?.client_id;

  /*eslint-disable */
  useEffect(() => {
    dispatch(getAllInstitutionsRequest());
  }, []);
  /* eslint-enable */

  function handleBack() {
    navigate(-1);
  }

  function handleShowLogs() {
    showErrorLogModal(doc.repair_error_message);
  }

  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle
          sm="4"
          title="Registro de Reparos"
          subtitle="Logs"
          className="text-sm-left"
        />
      </Row>

      <Row className="mb-3">
        <Col md="12">
          <button
            type="button"
            onClick={handleBack}
            className="text-decoration-none h5 text-primary"
            style={{
              cursor: 'pointer',
              background: 'none',
              border: 'none',
              padding: 0,
            }}
          >
            <FiArrowLeft /> <span className="ml-1">Voltar</span>
          </button>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card small className="mb-4">
            <CardHeader className="border-bottom">
              <h6 className="mt-1 mr-3 mb-0">Detalhes do reparo</h6>
            </CardHeader>
            <CardBody className="p-0 overflow-auto">
              {!doc ? (
                <div className="col-sm-12 d-flex justify-content-center">
                  <h5 className="mt-3">
                    <FiAlertCircle className="mr-2" />
                    Informações do documento não disponíveis.
                  </h5>
                </div>
              ) : (
                <table className="table m-0">
                  <tbody>
                    <tr>
                      <td>Instituição</td>
                      <td>{institutionLabel}</td>
                    </tr>
                    <tr>
                      <td>Seu número</td>
                      <td>{doc.your_number}</td>
                    </tr>
                    <tr>
                      <td>Id do documento</td>
                      <td>{doc.document_id ?? '-'}</td>
                    </tr>
                    <tr>
                      <td>Tipo de documento</td>
                      <td>
                        {documentTypeLabelByValue[doc.document_type] ||
                          doc.document_type ||
                          'não disponível'}
                      </td>
                    </tr>
                    <tr>
                      <td>Grupo de reparo</td>
                      <td>
                        {documentFixGroupLabelByValue[doc.document_fix_group] ||
                          doc.document_fix_group ||
                          'não disponível'}
                      </td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>
                        {repairResultStatus[doc.repair_result] ||
                          doc.repair_result}
                      </td>
                    </tr>
                    <tr>
                      <td>Data/Hora</td>
                      <td>
                        {doc.date_time ? dateAndSeconds(doc.date_time) : '-'}
                      </td>
                    </tr>
                    <tr>
                      <td>Logs de erro</td>
                      <td>
                        <Button
                          size="sm"
                          theme="white"
                          disabled={doc.repair_result !== 'error'}
                          onClick={handleShowLogs}
                        >
                          <span className="text-light">
                            <FiZoomIn />
                          </span>{' '}
                          Logs
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
